export default __webpack_public_path__ + "static/media/Mask London.baeab1f1.png";